import type { ReactNode } from 'react';
import AppsIcon from '@mui/icons-material/Apps';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import SecurityIcon from '@mui/icons-material/Security';
import RateReviewIcon from '@mui/icons-material/RateReview';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HistoryIcon from '@mui/icons-material/History';
import DashboardIcon from '@mui/icons-material/Dashboard';
import type { VysorQuickAction } from './vysorCatalog';
import { WIZOR_FLOW_BY_ID, type WizardFlow, canRunVysorWizard } from './vysorFlows';

export interface VysorQuickActionUi extends VysorQuickAction {
  icon: ReactNode;
  color: string;
  onClick: () => void;
}

const ACTION_STYLE: Record<string, { color: string; Icon: typeof AppsIcon }> = {
  'setup-app': { color: '#1976d2', Icon: AppsIcon },
  'configure-sso': { color: '#7b1fa2', Icon: VpnKeyIcon },
  'iga-entitlements': { color: '#2e7d32', Icon: SecurityIcon },
  'sso-review': { color: '#1565c0', Icon: RateReviewIcon },
  'ai-governance': { color: '#6a1b9a', Icon: SmartToyIcon },
  'my-apps': { color: '#00838f', Icon: DashboardIcon },
  reports: { color: '#455a64', Icon: AssessmentIcon },
  'audit-trail': { color: '#5d4037', Icon: HistoryIcon },
};

export function mapQuickActionsToUi(
  actions: VysorQuickAction[],
  handlers: {
    onWizard: (flow: WizardFlow) => void;
    onNavigate: (path: string) => void;
    userRole?: string;
  },
): VysorQuickActionUi[] {
  return actions
    .filter(action => !action.flowId || canRunVysorWizard(handlers.userRole, action.flowId))
    .map(action => {
    const style = ACTION_STYLE[action.id] || { color: '#546e7a', Icon: AppsIcon };
    const Icon = style.Icon;
    return {
      ...action,
      icon: <Icon sx={{ fontSize: 18 }} />,
      color: style.color,
      onClick: () => {
        if (action.actionType === 'navigate' && action.path) {
          handlers.onNavigate(action.path);
          return;
        }
        if (action.flowId && WIZOR_FLOW_BY_ID[action.flowId]) {
          const flow = WIZOR_FLOW_BY_ID[action.flowId];
          handlers.onWizard(flow);
        }
      },
    };
  });
}
